import { render } from "./OTPInvitationVerifyPage.vue?vue&type=template&id=511bd82e&ts=true"
import script from "./OTPInvitationVerifyPage.vue?vue&type=script&lang=ts"
export * from "./OTPInvitationVerifyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/OTPInvitationVerifyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "511bd82e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('511bd82e', __exports__)) {
    api.reload('511bd82e', __exports__)
  }
  
  module.hot.accept("./OTPInvitationVerifyPage.vue?vue&type=template&id=511bd82e&ts=true", () => {
    api.rerender('511bd82e', render)
  })

}


export default __exports__